import { styled, Grid } from '@mui/material';
import React from 'react';
import brandclub_colors from '../../../colors/brandclubColors.js';
import { formatMoney } from '../../../utils/stringUtils.js';

var Container = styled('div')({
    width: 340,
    marginLeft: 'auto',
    marginRight: 'auto',
    '.row': {
        display: 'flex',
        justifyContent: 'space-between',
        padding: '7.5px 0',
        ':nth-last-of-type(2)': {
            paddingBottom: 20,
        },
    },
    '.total-row': {
        fontWeight: 600,
        borderTop: "1px solid ".concat(brandclub_colors.blueWhiteBorder),
        padding: '20px 0 15px',
    },
});
var RewardTable = function (_a) {
    var rows = _a.rows, _b = _a.containerStyle, containerStyle = _b === void 0 ? {} : _b;
    var totalRewards = rows.reduce(function (acc, _a) {
        var amount = _a[1];
        return acc + amount;
    }, 0);
    return (React.createElement(Container, { style: containerStyle },
        rows.map(function (row, index) { return (React.createElement(Grid, { key: index, container: true, className: "row" },
            React.createElement(Grid, { item: true }, row[0]),
            React.createElement(Grid, { item: true }, formatMoney(row[1])))); }),
        React.createElement(Grid, { container: true, className: "row total-row" },
            React.createElement(Grid, { item: true }, "Total rewards"),
            React.createElement(Grid, { item: true }, formatMoney(totalRewards)))));
};

export { RewardTable };
//# sourceMappingURL=RewardTable.js.map
